import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgBakerySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25a5.728 5.728 0 00-3.55 1.226 4.75 4.75 0 00-4.63 8.054l1.055 7.026a3.75 3.75 0 003.709 3.194h6.832a3.75 3.75 0 003.709-3.194l1.054-7.027a4.75 4.75 0 00-4.63-8.054A5.728 5.728 0 0012 2.25zm-2.75 18h1.5V15a.75.75 0 00-1.5 0v5.25zm4 0h1.5V15a.75.75 0 00-1.5 0v5.25zm7-12.25c0 .873-.344 1.665-.905 2.25H4.655A3.25 3.25 0 018.3 5.02l.45.197.36-.334A4.232 4.232 0 0112 3.75c1.116 0 2.13.43 2.89 1.133l.36.334.45-.197A3.25 3.25 0 0120.25 8z",
    fill: "currentColor"
  })));
}

export { SvgBakerySolid as ReactComponent };
